<template>
  <div>

    <select class="form-control select2" multiple="multiple" style="width: 100%;">
        <option
          v-for="(item,index) in data"
          :data="item"
          :selected="item.selected"
          :key="index"
          :value="item.id">
        {{$t(item.text)}}</option>
    </select>
  </div>
</template>

<script>
import 'select2';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-theme/dist/select2-bootstrap.min.css';
export default {
  name: 'sectionselect2',
  props: {
    data: {
      type: Array,
      default() {
          return [
              {
                  id: 0,
                  text: '',
                  status: ''
              }
          ]
      }
    },
    placeHolder: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data () {
    return {
        selected: ''
    }
  },
  methods: {
    formatState: function(item) {
        this.selected = item;
        this.$emit('selectData', this.selected);
        return item.text;
    }
  },
  mounted () {
    $(this.$el).find('.select2').select2({
      placeholder: this.placeHolder,
      templateSelection: this.formatState
    }).on("select2:unselect", (e) => {
      this.$emit('unselectData', e.params.data);
    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.select2-search--inline, .select2-search__field {width: 1em; }
>>>.select2-container--default .select2-selection--multiple {
    background-color: white;
    border-color: rgb(210, 214, 222) !important;
    border-radius: 0px;
    cursor: text;
}
>>>.select2-container .select2-selection--single .select2-selection__rendered {
  margin-top: 0px;
}
>>>.select2-container--default .select2-selection--multiple{ /*color border */
    border-color: #d2d6de;
    padding: 1px 8px;
}
/* .select2-container--default .select2-selection--multiple .select2-selection__rendered .select2-search__field{
    padding: 1px 8px;
    color:#000;
} */
>>>.select2-container--default .select2-search--inline {
  width: 0px !important;
}
>>>.select2-container--default .select2-selection--multiple .select2-selection__choice {
    background-color: #00a65a;
}
>>>.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
    color: brown;
}
>>>.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:hover {
    color: #fff;
}
[class^='select2'] {
  border-radius: 0px !important;
  border-color: #ccc;
  box-shadow: none;
  font-size: 14px;
  color: #555;
  font-family: inherit;
}
::placeholder{ color:#999; opacity: 1;}
</style>



// WEBPACK FOOTER //
// src/components/LTESelect2Section.vue